var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommitments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7474 8.99874H3.49646",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7474 15.0012H3.49646",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7474 12H1.99583",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63335 5.63334C8.20841 3.05829 12.0811 2.28796 15.4456 3.68157C18.81 5.07518 21.0037 8.35828 21.0037 12C21.0037 15.6416 18.81 18.9247 15.4456 20.3183C12.0811 21.7119 8.20841 20.9416 5.63335 18.3666",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57764 9.38076L10.4917 11.6205C10.5905 11.8626 10.5905 12.1338 10.4917 12.3759L9.57654 14.6194C9.41671 15.0111 9.52063 15.4611 9.83607 15.7431C10.1515 16.0251 10.6102 16.0782 10.9817 15.8756L16.4805 12.8781C16.802 12.7028 17.002 12.3659 17.002 11.9997C17.002 11.6336 16.802 11.2966 16.4805 11.1214L10.9828 8.12438C10.6113 7.92183 10.1525 7.97492 9.83706 8.25696C9.52163 8.539 9.41775 8.98899 9.57764 9.38076Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0017 12H10.9996",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitments);
export default __webpack_public_path__ + "static/media/commitments.44d8e066998db63ee43851f4d8f730ee.svg";
export { ForwardRef as ReactComponent };